/** `m:ss` for a length in whole seconds — a recording timer, a voice memo's duration. */
export const formatClockDuration = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
